module.exports = __webpack_public_path__ + "static/media/add-group.2cfdae0e.svg";